import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { ICustomerNumberCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class CustomerNumberCredentialsStore implements ICredentialsStore {
    private _changes: ICustomerNumberCredentialsModel = {} as ICustomerNumberCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get customerNumber() { return this._changes.customer_number; };
    public get apiSecret() { return this._changes.api_secret; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setApiSecret(value: string) {
        this._changes.api_secret = value;
    };

    setCustomerNumber(value: string) {
        this._changes.customer_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default CustomerNumberCredentialsStore;
